<form (ngSubmit)="onSubmit()" class="row" [formGroup]="form">
  <div class="col-12">
    <uni-form-field [showCharactersCount]="true">
      <uni-label>Descripción:</uni-label>
      <textarea uniInput formControlName="description" rows="6" maxlength="500"></textarea>
    </uni-form-field>
  </div>

  <div class="col-md-12" *ngIf="requiredInfo.showStage">
    <div class="form-group">
      <label for="stage">Etapa:</label> <span *ngIf="isStagesRequired" class="required-mark"> * </span>
      <uni-select formControlName="stage" bindLabel="sNombre" labelForId="stage" [items]="stages$ | async"> </uni-select>
    </div>
  </div>

  <ng-container *ngIf="showInvoicesForm">
    <div class="col-12 mt-4 mb-3">
      <h2 uni-heading weight="semibold" alignText="center">Facturas</h2>
    </div>
    <div class="col-md-12" *ngIf="requiredInfo.showInvoiceQuantity">
      <uni-form-field>
        <uni-label>Cantidad de Facturas:</uni-label>
        <input uniInput formControlName="invoiceQuantity" type="number" />
      </uni-form-field>
    </div>

    <div *ngIf="requiredInfo.showCurrency" class="col-3">
      <div class="form-group">
        <label for="currency">Moneda:</label> <span *ngIf="isCurrencyRequired" class="required-mark"> * </span>
        <uni-select
          labelForId="currency"
          bindValue="key"
          bindLabel="iDsiglas"
          [items]="currencies$ | async"
          formControlName="currency"
        ></uni-select>
      </div>
    </div>

    <div *ngIf="requiredInfo.showAmount" class="col-9">
      <uni-form-field>
        <uni-label>Monto:</uni-label>
        <input uniInput formControlName="amount" format="currency" />
      </uni-form-field>
    </div>
  </ng-container>

  <ng-container *ngIf="showClientForm">
    <div class="col-12 mt-4 mb-3">
      <h2 uni-heading weight="semibold" alignText="center">Sobre el Cliente</h2>
    </div>
    <div class="col-12">
      <uni-form-field>
        <uni-label>Nombre del Cliente:</uni-label>
        <input uniInput formControlName="customerName" />
      </uni-form-field>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label>Tipo de Identificación:</label> <span class="required-mark"> * </span>
        <uni-select
          formControlName="identificationType"
          bindLabel="sNombreID"
          [items]="identificationTypes$ | async"
        ></uni-select>
      </div>
    </div>

    <div class="col-md-6">
      <uni-form-field>
        <uni-label>Número de Identificación</uni-label>
        <input
          uniInput
          formControlName="identification"
          [format]="
            fiduciaryIdentificationType.Cedula.toString() === currentIdentificationType?.key
              ? '000-0000000-0'
              : 'AAAAAAAAAAAAAAAAAA'
          "
        />
      </uni-form-field>
    </div>

    <div class="col-12">
      <div class="form-group">
        <label>Tipo de Cliente:</label> <span class="required-mark"> * </span>
        <uni-select formControlName="customerType" bindLabel="sNombre" [items]="customerTypes$ | async"></uni-select>
      </div>
    </div>
  </ng-container>

  <ng-container formGroupName="informations" *ngIf="additionalInformationsFields?.length">
    <div class="col-12 mt-4 mb-3">
      <h2 uni-heading weight="semibold" alignText="center">Información Adicional</h2>
    </div>
    <div class="col-md-6" *ngFor="let field of additionalInformationsFields">
      <uni-form-field>
        <uni-label>{{ field.nameInformation }}:</uni-label>
        <input uniInput [formControlName]="field.sCode" />
      </uni-form-field>
    </div>
  </ng-container>

  <div class="col-12 text-right pt-5">
    <button [disabled]="form.invalid" type="submit" uni-button uniStepperNext icon="chevron-right">Siguiente</button>
  </div>
</form>
